"use client"

import React from "react"
import { EditIcon, PlusIcon } from "lucide-react"
import { useTranslations } from "next-intl"

import { UserData } from "@/lib/intershop/interfaces/user/user"
import { ExtendedAddressRO } from "@/lib/storefront/addresses/address"
import { Button } from "@/components/ui/components"
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from "@/components/ui/components/sheet"
import EditOrCreateAddress from "@/components/common/addresses/EditOrCreateAddress"

interface AddressEditSheetProps {
  address: any
  customer: any
  user: any
  mode: "add" | "edit"
  type: "invoiceTo" | "shipTo" | "general"
  onSave?: (a: ExtendedAddressRO, u: UserData) => void
}

export default function AddressEditSheet({ address, customer, user, mode, type, onSave }: AddressEditSheetProps) {
  const t = useTranslations("storefront")
  const [open, setOpen] = React.useState(false)

  function onSaveInternal(newAddress: ExtendedAddressRO) {
    if (onSave) {
      onSave(newAddress, user)
    }
    setOpen(false)
    //window.location.reload()
  }

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        {mode === "edit" ? (
          <button className="focus-visible:outline-primary focus:outline-primary focus:outline-1 focus-visible:outline-1">
            <EditIcon className="size-5" />
          </button>
        ) : (
          <Button size={"smNoGrow"} variant={"outline_secondary"} className="">
            <PlusIcon strokeWidth={1} className="inline" />
            <span className="ml-2">{t("forms.edit_address_form.add")}</span>
          </Button>
        )}
      </SheetTrigger>
      <SheetContent side={"right"} className={"bg-ub-background"}>
        <SheetTitle className={"hidden"}>{t("category.additional_filter")}</SheetTitle>

        <div className="size-full">
          <h2 className="mb-4 text-lg font-bold">
            {mode === "add" ? t("forms.edit_address_form.add") : t("forms.edit_address_form.edit")}
          </h2>
          <EditOrCreateAddress
            address={address}
            customer={customer}
            user={user}
            onSave={onSaveInternal}
            mode={mode}
            type={type}
          />
        </div>
      </SheetContent>
    </Sheet>
  )
}
